import NavbarSection from "../../components/NavbarSection";
import HeroSection from "../../components/HeroSection";

function Header() {
  return (
    <div className="header">
      <NavbarSection />
      <HeroSection />
    </div>
  );
}

export default Header;
